// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchSavedItemCountsParams = {
    deployment: string,
    itemIds: number[],
};

type PostSaveItemParams = {
    authToken: string,
    deployment: string,
    itemId: number,
};

type PostUnsaveItemParams = {
    authToken: string,
    deployment: string,
    itemId: number,
};

export default {
    fetchSavedItemCounts: ({ deployment, itemIds }: FetchSavedItemCountsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ deployment, path: '<ITEM-API>saved-items/count' });
            request.send({ ids: itemIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postSaveItem: ({ authToken, deployment, itemId }: PostSaveItemParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: `<ITEM-API>saved-items/save/${itemId}` });
            request.send({ itemId });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postUnsaveItem: ({ authToken, deployment, itemId }: PostUnsaveItemParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: `<ITEM-API>saved-items/unsave/${itemId}` });
            request.send({ itemId });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
